<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="localVisible"
    width="520px"
    :title="dialogTitle"
    @close="resetDialog"
  >
    <el-divider></el-divider>
    <div class="import-dialog-content">
      <div class="import-template-row">
        <span>模板文件：</span>
        <a :href="templateDownloadUrl" target="_blank" rel="noopener noreferrer">下载模板</a>
      </div>
      <div class="import-tip">
        请先下载模板，在模板中填写需要导入的手机号后，再上传文件。
      </div>
      <el-upload
        class="upload-demo"
        drag
        action="http://xwt.softykt.net/api/res/addResFile"
        :show-file-list="false"
        accept=".xls,.xlsx"
        :before-upload="beforeUpload"
        :on-success="attachUploadSuccess"
        :on-error="handleUploadError"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ path ? '已上传文件，点击可重新上传' : '将文件拖到此处，或' }}<em v-if="!path">点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">仅支持 Excel 文件（.xls / .xlsx）</div>
      </el-upload>
      <div v-if="selectedFileName" class="selected-file">
        已选择文件：{{ selectedFileName }}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="localVisible = false">取消</el-button>
      <el-button type="primary" :loading="importSubmitting" @click="submitImportFile">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { massTexting, importMobile } from '@/request/scenic.js'
import { Message } from 'element-ui'

export default {
  name: 'SmsImportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    importType: {
      type: String,
      default: 'mass' // mass | mini
    }
  },
  data() {
    return {
      templateDownloadUrl: 'https://jinfeiying.oss-cn-beijing.aliyuncs.com/%E6%89%8B%E6%9C%BA%E5%8F%B7.xlsx',
      path: '',
      selectedFileName: '',
      importSubmitting: false
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return this.importType === 'mass' ? '群发短信' : '会员导入小程序'
    }
  },
  methods: {
    beforeUpload(file) {
      const isExcel = /\.xlsx?$/.test((file.name || '').toLowerCase())
      if (!isExcel) {
        Message.error('仅支持上传 .xls 或 .xlsx 文件')
        return false
      }
      this.selectedFileName = file.name
      return true
    },
    attachUploadSuccess(res) {
      if (res && res.result) {
        this.path = res.result
        Message.success('文件上传成功')
      } else {
        this.path = ''
        Message.error((res && res.msg) || '文件上传失败')
      }
    },
    handleUploadError() {
      this.path = ''
      Message.error('文件上传失败，请稍后重试')
    },
    resetDialog() {
      this.path = ''
      this.selectedFileName = ''
      this.importSubmitting = false
    },
    submitImportFile() {
      if (!this.path) {
        Message.error('请先上传Excel文件')
        return
      }
      const data = {
        token: window.sessionStorage.getItem('Token'),
        path: this.path
      }
      if (this.importType === 'mass') {
        data.ScenicID = window.sessionStorage.getItem('ScenicId')
      }
      this.importSubmitting = true
      const req = this.importType === 'mass' ? massTexting(data) : importMobile(data)
      req.then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200 || res.data.rcode == '200')) {
          Message.success(res.data.msg || '操作成功')
          this.localVisible = false
          this.$emit('success')
        } else {
          Message.error((res.data && res.data.msg) || '操作失败')
        }
      }).catch(() => {
        Message.error('操作失败，请稍后重试')
      }).finally(() => {
        this.importSubmitting = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.import-dialog-content {
  padding: 6px 0 8px;
}
.import-template-row {
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
  a {
    color: #246deb;
  }
}
.import-tip {
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f4f7ff;
  color: #5f6b7a;
  font-size: 13px;
  line-height: 20px;
}
.selected-file {
  margin-top: 10px;
  font-size: 13px;
  color: #67c23a;
  word-break: break-all;
}
</style>
